var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"explain-right-body br5"},[_c('div',{staticClass:"ex-tit fl"},[_c('h1',[_vm._v(_vm._s(_vm.commonTitle))]),_c('p')]),_c('div',{staticClass:"ex-nr",domProps:{"innerHTML":_vm._s(_vm.unescapeHTML(_vm.commonArticle))}})])}
var staticRenderFns = []

export { render, staticRenderFns }